(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('JobsQueueService', JobsQueueService);

  JobsQueueService.$inject = ['$resource'];

 	function JobsQueueService ($resource) {
    return $resource(apiUrl + '/jobs-queue', {}, {
      getAllJobsQueue: { url: apiUrl + '/jobs-queue/get-all', method: 'GET', params: {}, isArray: false }
    });
  }
})();
